import HTTP from "@/_helpers/http";
import { BANK__API } from "@/_helpers/urls";
import { BANK__MUTATIONS } from "../mutation-types";
import { BANK__ACTIONS } from "../action-types";
import toast from "@/services/Notification";
import router from "@/router";

// State
const state = {
    banks: [],
    bank: {},
};

//Getters
const getters = {};

//Mutations
const mutations = {
    [BANK__MUTATIONS.GETALL](state, data) {
        state.banks = data;
    },
    [BANK__MUTATIONS.DETAILS](state, data) {
        state.bank = data;
    },
};

// Actions
const actions = {
    async [BANK__ACTIONS.DELETEBANK]({ commit, state }, id) {
    try {
        const url = `${BANK__API.DELETEBANK}/${id}`;
        await HTTP({
            trackProgress: true,
            loadingText: 'Processing...'
        }).get(url);
        const updatedBanks = state.banks.filter(bank => bank.id !== id);
        commit(BANK__MUTATIONS.GETALL, updatedBanks);

    } catch (error) {
        console.log(error);
    }
},
    async [BANK__ACTIONS.GETALL]({ commit, state }) {
        try {
            const url = `${BANK__API.GETALL}`;
            const response = await HTTP({
                trackProgress: true,
                loadingText: 'Processing...'
            }).get(url);
            commit(BANK__MUTATIONS.GETALL, response.data);
        } catch (error) {
            console.log(error);
        }
    },

    async [BANK__ACTIONS.DETAILS]({ commit, state }, id) {
        try {
            const url = `${BANK__API.DETAILS}/${id}`;
            const response = await HTTP({
                trackProgress: true,
                loadingText: 'Processing...'
            }).get(url);
            commit(BANK__MUTATIONS.DETAILS, response.data);
        } catch (error) {
            console.log(error);
        }
    },

    async [BANK__ACTIONS.CREATE]({ commit, state, dispatch }, data) {
        try {
            const url = `${BANK__API.CREATE}`;
            const res = await HTTP({
                trackProgress: true,
                loadingText: 'Processing...'
            }).post(url, data);
            toast.success(res.data.message)
            dispatch(BANK__ACTIONS.GETALL);
            setTimeout(() => {
                router.push('/bank-information?tab=2')
            }, 1000)
        } catch (error) {
            console.log(error);
        }
    },
};

export default {
    namespaced: true,
    strict: process.env.NODE_ENV !== "production",
    state,
    getters,
    mutations,
    actions,
};
